import { render, staticRenderFns } from "./SalesTaxPermitList.vue?vue&type=template&id=7b30bc04&scoped=true&"
import script from "./SalesTaxPermitList.vue?vue&type=script&lang=ts&"
export * from "./SalesTaxPermitList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b30bc04",
  null
  
)

export default component.exports